import React from 'react'
import { Container } from 'reactstrap'

const Loading = () => {
    return (
        <Container className='my-5 text-center'>
            <p className='display-4'>Loading...</p>
        </Container>
    )
}

export default Loading
